import { moment } from '../../../helpers/utils';
export default
{
    methods: {
        loadPeriodRange()
        {
            const months = [];
            for (let i = this.config.periodRange; i>=0; i--) {
                let dateMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                dateMonth.setMonth(dateMonth.getMonth() - i);
                months.push(`${this.config.monthLabel[dateMonth.getMonth()]} ${dateMonth.getFullYear()}`);
            }
            this.config.monthRange = months;
        },
        formatMoney( valor )
        {
            valor = parseFloat(valor).toFixed(2).split('.');
            valor[0] = valor[0].split(/(?=(?:...)*$)/).join('.');
            return valor.join(',');
        },
        downloadTable()
        {
            const dataCsv = [];
            this.table.data.forEach(row => {
                const newRow = {};
                this.table.columns.forEach((coluna, index) => {
                    if (row[coluna.key]) {
                        newRow[coluna.title] = row[coluna.key].toString().replace(/,/g, " ").replace(/\n+/, " ");
                    } else {
                        newRow[`Coluna ${index}`] = " ";
                    }
                });
                dataCsv.push(newRow);
            });

            this.$refs.table.exportCsv({
                filename: this.$refs.table.name,
                columns: this.table.columns
            })
        },
        formatDate(date)
        {
            return moment(date).format('DD-MM-YYYY');
        }
    }
}